
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import LZString from 'lz-string';
import Cookie from 'js-cookie';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import { Config } from '../config/config';
import logo from "../../assets/logodecath.png";
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { Modal, Button, } from 'antd'
import * as Yup from 'yup';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {isLoginOrNot} from '../pages/Store/actions/storeService'
class Login extends Component {
  constructor(props) {
    super(props);
    localStorage.removeItem('Login');
    localStorage.removeItem('stores');
    localStorage.removeItem('warehouses');

    Cookie.remove('currentUser');
    Cookie.remove('stores');
    Cookie.remove('storesAll');
    Cookie.remove('warehouses');
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    const config = JSON.parse(Config);
    this.state = {
      redirect: null,
      redirectionURL: '',
      title: 'Welcome to Decathlon',
      login: false,
      loading: false,
      message: '',
      userID: '',
      strData: [],
      wrData: [],
      navigate: false,
      apiInterface1:config['api1'],
      apiInterface: config['api'],
      apiInterfaceExternal: config['api2'],
      apiInterfaceUserInfo: config['api3'],
      apiInterfaceExternalProd:config['api4'],
      modalOpen: false,
      isChangePasswordOpen: false,
      isForgotPasswordOpen: false,
      isModalVisible: false,
      token: null,
      UserName: "",
      //UserName: 'AABHI02',
      Password: '',
      response:[],
      //UserName: "SKURIA08",
      // Password: 'Test123',

      forgotUserId:'',
      forgotEmail:'',

      changeUserId:'',
      changeEmail:'',
      oldPassword:'',
      newPassword:'',
      isSubmit:false,
    };
  }
  _doLogin = (fields) => {
    console.log(this.state)
    this.setState({
      loading: true,
      modalOpen: false,
      isOpenpasswordModal: false,
      isForgotPasswordOpen: false,
      isModalVisible: false,
      message: "",
    });
    const LoginData = {
      userId: fields.UserName,
      password: fields.Password,
      appType: "Web"
    }
    ApiGateWay.ExternalToken(this.state.apiInterfaceExternalProd + '/externalUserLogin', LoginData)
      .then((response) => {
        console.log(response,'contentData');
        if (response.errorMessage) {
          console.log(response);
          this.setState({
            modalOpen: true,
            message: response.errorMessage,
            loading: false,
          })
        }
        else if (response.message) {
          this.setState({
            modalOpen: true,
            message: response.message,
            loading: false,
          })
        }
        else {
          Cookie.set('token', response.token);
          localStorage.setItem('token', response.token)
          this._doGetUserInfo();
        }
      })
      .catch(() => {
        this.setState({
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      })

  }
  _doGetUserInfo() {
    let redirectionMenu = [];
    let urlRedirect = '';
    // ApiGateWay.paramsPost('/dsi_aristi_v1/api/fetchUserInfo', Cookie.get("token"))
    ApiGateWay.paramsPost('/dsi_aristi/api/fetchUserInfo', Cookie.get("token"))
      .then((response) => {
        console.log("UserInforDatalsjkflaskjfowej", response)
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired'
        ) {
          this.setState({
            loading: false,
            modalOpen: true,
            message: response.errorMessage,
          });
            this.props.isLoginOrNot(false)
            localStorage.setItem("isLogin",false)
          return (window.location = '/');
        }

        if (response) {
          this.props.isLoginOrNot(true);
          localStorage.setItem("isLogin", true)
          console.log(response['userInfo'],'userinfochecking')
          this._doGetStoreInfo(response['userInfo']['user_id']);
          localStorage.setItem("UserLoggedinId",response['userInfo']['user_id'])
          if(response['userInfo']['moduleAccess'][0]['featureAccess'])  //if module has features inside
          response['userInfo']['moduleAccess'][0]['featureAccess'].map(
            (featureAccess) => {
              if (featureAccess.value == 1) {
                redirectionMenu.push(featureAccess.featureName);
              }
            }
          );
          else if(response['userInfo']['moduleAccess'][0].value == 1)  { //if module does not have features inside
              redirectionMenu.push(response['userInfo']['moduleAccess'][0]);
          }
          if (redirectionMenu[0] == 'Global Dashboard - Retail') {
            urlRedirect = '/dashboardRetail';
          } else if (redirectionMenu[0] == 'Store Dashboard') {
            urlRedirect = '/storeDashboardRetail';
          } else if (redirectionMenu[0] == 'Global Dashboard - Logistics') {
            urlRedirect = '/dashboardRetail';
          } else if (redirectionMenu[0] == 'Warehouse Dashboard') {
            urlRedirect = '/dashboardWareHouse';
          } else if(redirectionMenu[0]?.featureName =="TPV"){
            urlRedirect = '/tpv';
          }

          const dataString = JSON.stringify({
            roles: response['userInfo']['roles'],
            token: response['userInfo']['token'],
            moduleAccess: response['userInfo']['moduleAccess'],
            userId: response['userInfo']['user_id'],
            emailId: response['userInfo']['email_id'],
            givenName: response['userInfo']['givenName'],
            surName: response['userInfo']['surname'],
            designation: response['userInfo']['designation'],
          },
          {
            secure: true,
            sameSite: 'strict',
          });
          const compressedData = LZString.compressToBase64(dataString);
          Cookie.set(
            'currentUser',
            compressedData
          );
          localStorage.setItem('currentUser', dataString)

          this.setState({
            redirectionURL: urlRedirect,
            userID: response['userInfo']['user_id'],
            loading: false,
            login: true,
          });

        }

      }, () => {
        this.setState({
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      })
  }

  _doGetStoreInfo(UserId) {
    console.log("UserId", UserId)
    ApiGateWay.PostCall(this.state.apiInterfaceExternalProd+'/api/fetchStoreInfo', {
      userId: UserId,
      cityIds: '',
      appType: 'Web',
    })
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');
          localStorage.clear();
          sessionStorage.clear();
        }

        if (response['storesInfos'][0]['storeType'] === 'Store') {
          this.setState({
            response:response
          })
          localStorage.setItem(
            'storeData',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'warehouseData',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );
          this.setState({
            navigate: true,
            strData: response['storesInfos'][0]['storeLocationsInfos'],
            wrData: response['storesInfos'][1]['storeLocationsInfos'],
          });
        } else {
          localStorage.setItem(
            'storeData',
            JSON.stringify(response['storesInfos'][1]['storeLocationsInfos'])
          );
          localStorage.setItem(
            'warehouseData',
            JSON.stringify(response['storesInfos'][0]['storeLocationsInfos'])
          );
          this.setState({
            navigate: true,
            strData: response['storesInfos'][1]['storeLocationsInfos'],
            wrData: response['storesInfos'][0]['storeLocationsInfos'],
          });

        }
        if(response['storesInfos'][0]['storeLocationsInfos'][0]['storeId']==100){
          // this.props.navigate('/PMPVendorList');
          this.setState({
            redirect: '/PMPVendorList',
          });
        }
        const currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if(currentUser['roles']?.[0] == 'Auditor'){
          // this.props.navigate('/tpv');
          this.setState({
            redirect: '/tpv',
          });
        }
      }

      )
      .catch(() => {
        this.setState({
          navigate: false,
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      });
    console.log()
    // setTimeout(() => {
    //   // this.props.navigate("/stores");
    //   console.log(this.responseData,'responsedata')
    //   console.log(this.state.response,'this.state.repsonse')
    //   if(this.state.response['storesInfos'][0]['storeLocationsInfos'][0]['storeId']==100){
    //     this.props.navigate('/PMPVendorList');
    //   }
    // }, 1000)
  }

  _doLoginFedId = () => {
    window.location.href = process.env.REACT_APP_LOAD_URL;
  }

  _doGetUserName = (e) => {
    this.setState({
      UserName: e.target.value
    })
  }

  _doGetPassword = (e) => {
    this.setState({
      Password: e.target.value
    })
  }
  
  _doOpenChangePasswordModal = (e) => {
    this.setState({
      isChangePasswordOpen: true,
      isModalVisible: true
    })
  }
  _doCloseChangePasswordModal = (e) => {
    this.setState({
      isChangePasswordOpen: false,
      isModalVisible: false,
      isSubmit:false,
    })
  };

  doChangePassWord = () =>{
    const {changeUserId, changeEmail, oldPassword, newPassword, apiInterface1} = this.state
    this.setState({isSubmit:true})
    if(changeUserId== '') return;
    else if(changeEmail== '') return;
    else if(oldPassword== '') return;
    else if(newPassword == '') return;

    let data ={
      fedid: changeUserId,
      email : changeEmail,
      existingpassword : oldPassword,
      newpassword : newPassword
    }
    console.log(data,'data')
    ApiGateWay.SaveData(
      apiInterface1 +
      '/VendorInfo/changepassword',data)
      .then((response) => {
        console.log(response,'contentData');
        if (response[0]['Table1'][0].status_code == '000') {
          console.log(response);
          this.setState({
            modalOpen: true,
            message: response[1]['Table2'][0].status_msg,
            loading: false,
          })
        }
      })
      .catch(() => {
        this.setState({
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
        console.log('inside catch block for testing')
      })
      this.setState({
        isChangePasswordOpen: false,
        isModalVisible: false,
        isSubmit: false,
        changeUserId:'',
        changeEmail:'',
        oldPassword:'',
        newPassword:'',
      })
  }
  _doOpenForgotPasswordModal = (e) => {
    this.setState({
      isForgotPasswordOpen: true,
      isModalVisible: true
    })
  }
  _doCloseForgotPasswordModal = (e) => {
    this.setState({
      isForgotPasswordOpen: false,
      isModalVisible: false,
      isSubmit:false,
    })
  };
  doForgotPassword = ()=>{
    const {forgotUserId, forgotEmail, apiInterface1} = this.state
    this.setState({isSubmit:true})
    if(forgotUserId == '') return;
    else if(forgotEmail == '') return;
    let data ={
      fedid: forgotUserId,
      email : forgotEmail
    }
    console.log(data,'data')
    ApiGateWay.SaveData(apiInterface1 +'/VendorInfo/forgotpassword', data)
    .then((response) => {
      console.log(response,'contentData');
      if (response[0]['Table1'][0].status_code == '000') {
        console.log(response);
        this.setState({
          modalOpen: true,
          message: response[1]['Table2'][0].status_msg,
          loading: false,
        })
      }
    })
    this.setState({
      isForgotPasswordOpen: false,
      isModalVisible: false,
      isSubmit: false,
      forgotUserId:'',
      forgotEmail:'',
    })
  }
  handleClose = () =>{
    this.setState({
      modalOpen:false,
      message:'',
      loading:false,
    })
  }
  render() {
    const { loading, modalOpen, message } = this.state;
    if (this.state.redirect) {
      return (
        <Navigate
          to={{
            pathname: this.state.redirect,
          }}
        />
      );
    }
    return (
      <Formik
        initialValues={{
          UserName: '',
          Password: '',
        }}
        // Custom Validations 
        validationSchema={Yup.object().shape({
          UserName: Yup.string().required('Please Enter Username'),
          Password: Yup.string().required('Please Enter Password'),
        })}

        onSubmit={(fields, { resetForm }) => {
          console.log(fields)
          this._doLogin(fields);
        }}
        render={({ errors, touched, handleChange, handleBlur }) => (
          <div>
            {modalOpen ? (
              <MessageBox
                message={this.state.message}
                signout={false}
                onClose={this.handleClose}
              />
            ) : null}
            <div className='wrapper' style={{ background: 'white' }}>
              <div className='content-wrapper no-margin'>
                {loading ? (
                  <Spinner />
                ) : (
                  <Form className="m-form">
                    <div className="m-auth">
                      <div className="m-auth__container">
                        <div className="m-auth__img">

                        </div>
                        <div className="m-auth__form">
                          <div className="m-auth__logo">
                            <img className="m-login__logo" src={logo} alt="logo" />
                          </div>
                          <div className="m-auth-form">
                            <div className="m-auth-form__container">
                              <div className="m-auth-form__item">
                                <button type="button" className="m-auth-form__btn" onClick={this._doLoginFedId} >
                                  <span>Login With FED ID</span>
                                </button>
                              </div>
                              <div className="m-auth-form__item">
                                <h4 className="m-auth-form__text">Or</h4>
                              </div>
                              <div className="m-auth-form__item">
                                <Field type="text" placeholder="User ID" name="UserName" className={'form-control' + (errors.UserName && touched.UserName ? ' is-invalid' : '')}  
                                  onKeyPress={(e) => {
                                      if (new RegExp(/[a-zA-Z0-9_\s\.\-@]/i).test(e.key)) {
                                      } else e.preventDefault();
                                  }} 
                                />
                                <ErrorMessage name="UserName" component="span" className="text-danger" />
                              </div>
                              <div className="m-auth-form__item">
                                <Field type="password" placeholder="Password" name="Password" className={'form-control' + (errors.Password && touched.Password ? ' is-invalid' : '')}  
                                  onKeyPress={(e) => {
                                    if (new RegExp(/[a-zA-Z0-9_\s\.\-@]/i).test(e.key)) {
                                    } else e.preventDefault();
                                  }} 
                                />
                                <ErrorMessage name="Password" component="span" className="text-danger" />
                              </div>
                              <div className="m-auth-form__item top-more-space">
                                <button type="submit" className="m-auth-form__btn">
                                  <span>Login</span>
                                </button>
                                <div className='password_links'>
                                  <span onClick={this._doOpenChangePasswordModal} className='text-left text-secondary'>Change Password</span>
                                  <span onClick={this._doOpenForgotPasswordModal} className='text-right text-primary'>forgot Password ?</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
                {
                  this.state.isChangePasswordOpen == true ?
                    <Modal title="Change Password" className="password_modal" width={420} closeIcon open={this.state.isModalVisible}
                      footer={[
                        <Button key="back" danger onClick={this._doCloseChangePasswordModal}>
                          Cancel
                        </Button>,
                        <Button key="submit" type="primary" className='secondary' onClick={this.doChangePassWord}>
                          Submit
                        </Button>,
                      ]}>
                      <div className='row'>
                        <div className='col-md-12'>
                          <div className="m-auth-form__item">
                            <input type="text" placeholder="User ID" name="UserName" className='form-control' onChange={(e)=> this.setState({changeUserId:e.target.value.replace(/[^\w\s]/gi, "").trim()})} maxLength="100"/>
                            {this.state.changeUserId=='' && this.state.isSubmit == true && <span className='text-danger'>Please Enter User Id</span>}
                          </div>
                        </div>
                        <div className='col-md-12'>
                          <div className="m-auth-form__item">
                            <input type="email" placeholder="Email ID" name="Email" className='form-control' onChange={(e)=> this.setState({changeEmail:e.target.value.replace(/[^a-zA-Z0-9_@.]/gi,"").trim()})} maxLength="100"/>
                            {this.state.changeEmail=='' && this.state.isSubmit == true && <span className='text-danger'>Please Enter Email</span>}
                          </div>
                        </div>
                        <div className='col-md-12'>
                          <div className="m-auth-form__item">
                            <input type="password" placeholder="Old Password" name="OldPassword" className='form-control' onChange={(e)=> this.setState({oldPassword:e.target.value.trim()})}/>
                            {this.state.oldPassword=='' && this.state.isSubmit == true && <span className='text-danger'>Please Enter Old Password</span>}
                          </div>
                        </div>
                        <div className='col-md-12'>
                          <div className="m-auth-form__item">
                            <input type="password" placeholder="New Password" name="NewPassword" className='form-control' onChange={(e)=> this.setState({newPassword:e.target.value.trim()})}/>
                            {this.state.newPassword=='' && this.state.isSubmit == true && <span className='text-danger'>Please Enter New Password</span>}
                          </div>
                        </div>
                      </div>
                    </Modal>
                    : null
                }

                {
                  this.state.isChangePasswordOpen == true ?
                    <div className="overlay" onClick={this._doCloseChangePasswordModal}>

                    </div>
                    : null
                }
                {
                  this.state.isForgotPasswordOpen == true ?
                    <Modal title="Forgot Password" className='password_modal' width={420} closeIcon open={this.state.isModalVisible}
                      footer={[
                        <Button key="back" danger onClick={this._doCloseForgotPasswordModal}>
                          Cancel
                        </Button>,
                        <Button key="submit" type="primary" className='secondary' onClick={this.doForgotPassword}>
                          Submit
                        </Button>,
                      ]}>
                      <div className='row'>
                        <div className='col-md-12'>
                          <div className="m-auth-form__item">
                            <input type="text" placeholder="User ID" name="UserName" className='form-control' onChange={(e)=> this.setState({forgotUserId:e.target.value.replace(/[^\w\s]/gi, "").trim()})} maxLength="100"/>
                            {this.state.forgotUserId=='' && this.state.isSubmit == true && <span className='text-danger'>Please Enter User Id</span>}
                          </div>
                        </div>
                        <div className='col-md-12'>
                          <div className="m-auth-form__item">
                            <input type="email" placeholder="Email ID" name="Email" className='form-control' onChange={(e)=>this.setState({forgotEmail:e.target.value.replace(/[^a-zA-Z0-9_@.]/gi,"").trim()})} maxLength="100"/>
                            {this.state.forgotEmail=='' && this.state.isSubmit == true && <span className='text-danger'>Please Enter Email</span>}
                          </div>
                        </div>
                      </div>
                    </Modal>
                    : null
                }

                {
                  this.state.isForgotPasswordOpen == true ?
                    <div className="overlay" onClick={this._doCloseForgotPasswordModal}>

                    </div>
                    : null
                }
              </div>
            </div>
          </div>
        )
        }
      />

    );
  }
}
const mapDispatchToProps = dispatch =>({
  ...bindActionCreators({isLoginOrNot},dispatch)
})
const mapStateToProps = state =>({
})
export default connect(mapStateToProps, mapDispatchToProps)(Login);
